export class DataUri {
  private readonly mimeType: string
  public readonly dataPart: string

  constructor(public readonly source: string) {
    const parts = source.split(',')
    this.dataPart = parts[1]
    const types = parts[0].replace(/^data:/, '').split(';')
    const rawMimeType = types[0]
    this.mimeType = rawMimeType || 'text/plain'
  }

  toBlob(): Blob {
    // 本来の仕様は URI Encoding も認めているが、画像データ以外でこのクラスを使う予定はない。
    // base64 決め打ちで実装する
    const content = this.decodeBase64(this.dataPart)
    return new Blob([content], {
      type: this.mimeType
    })
  }

  toFile(fileName: string): File {
    // IE11 では使えないので注意。 IE11 では File のコンストラクタが存在しない
    return new File([this.toBlob()], fileName, { type: this.mimeType })
  }

  private decodeBase64(base64Content: string): Uint8Array {
    const binaryString = atob(base64Content)
    const content = new Uint8Array(binaryString.length)
    for (let i = 0; i < binaryString.length; i++) {
      content[i] = binaryString.charCodeAt(i)
    }
    return content
  }
}
